// Casos de uso y análisis de ROI para FluenceIA

export const useCasesData = [
  {
    id: 1,
    title: "Despacho de Abogados: Automatización de Gestión de Expedientes",
    industry: "Legal",
    client: "González & Asociados",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f",
    problemTitle: "El Problema",
    problem: "El despacho perdía 15 horas semanales en tareas administrativas: clasificación de documentos, seguimiento de plazos, recordatorios a clientes y actualización de expedientes. El equipo no podía centrarse en el trabajo jurídico de alto valor.",
    solutionTitle: "La Solución con IA",
    solution: "Implementamos un agente de IA que automatiza la gestión documental, clasifica expedientes, envía recordatorios automáticos a clientes y actualiza el estado de casos en tiempo real.",
    
    metrics: {
      timeSaved: "15 horas/semana",
      costReduction: "40%",
      productivityIncrease: "60%",
      roi: "350%",
      paybackPeriod: "2 meses"
    },
    
    impactBefore: [
      { metric: "Horas admin/semana", value: "15h" },
      { metric: "Errores documentales", value: "12/mes" },
      { metric: "Tiempo respuesta cliente", value: "48h" }
    ],
    
    impactAfter: [
      { metric: "Horas admin/semana", value: "3h" },
      { metric: "Errores documentales", value: "1/mes" },
      { metric: "Tiempo respuesta cliente", value: "2h" }
    ],
    
    features: [
      "Clasificación automática de documentos",
      "Alertas de plazos y vencimientos",
      "Seguimiento automatizado de clientes",
      "Generación de informes de estado",
      "Integración con sistema de gestión"
    ],
    
    testimonial: {
      text: "Recuperamos 12 horas semanales que ahora dedicamos a casos complejos. El ROI fue inmediato.",
      author: "María González",
      role: "Directora del Despacho"
    },
    
    date: "15 Enero 2026"
  },
  {
    id: 2,
    title: "Gestoría: Atención al Cliente 24/7 con Agente de IA",
    industry: "Gestoría y Asesoría",
    client: "Martínez Gestión",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85",
    problemTitle: "El Problema",
    problem: "Los clientes hacían consultas fuera del horario laboral que quedaban sin respuesta hasta el día siguiente. Esto generaba insatisfacción y pérdida de clientes potenciales que buscaban respuestas inmediatas.",
    solutionTitle: "La Solución con IA",
    solution: "Implementamos un agente conversacional de IA disponible 24/7 que responde consultas frecuentes, agenda citas, envía documentación y escala casos complejos al equipo humano con todo el contexto.",
    
    metrics: {
      timeSaved: "20 horas/semana",
      costReduction: "55%",
      productivityIncrease: "80%",
      roi: "420%",
      paybackPeriod: "1.5 meses"
    },
    
    impactBefore: [
      { metric: "Consultas sin respuesta", value: "45%" },
      { metric: "Tiempo respuesta promedio", value: "12h" },
      { metric: "Clientes perdidos/mes", value: "8" }
    ],
    
    impactAfter: [
      { metric: "Consultas sin respuesta", value: "5%" },
      { metric: "Tiempo respuesta promedio", value: "Instantáneo" },
      { metric: "Clientes perdidos/mes", value: "1" }
    ],
    
    features: [
      "Atención 24/7 sin interrupciones",
      "Respuestas a consultas frecuentes",
      "Agendado automático de citas",
      "Envío de documentación instantáneo",
      "Escalado inteligente a humanos"
    ],
    
    testimonial: {
      text: "Ahora atendemos a clientes fuera de horario y nunca perdemos una oportunidad. El agente trabaja mientras dormimos.",
      author: "Carlos Martínez",
      role: "Gerente"
    },
    
    date: "22 Enero 2026"
  },
  {
    id: 3,
    title: "Arquitectura: Automatización de Presupuestos y Seguimiento",
    industry: "Arquitectura",
    client: "Estudio Ruiz",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e",
    problemTitle: "El Problema",
    problem: "Crear presupuestos detallados tomaba 4-6 horas por proyecto. El seguimiento manual de múltiples proyectos simultáneos generaba retrasos y pérdida de información crítica sobre el estado de cada obra.",
    solutionTitle: "La Solución con IA",
    solution: "Implementamos un agente que genera presupuestos automáticos basados en especificaciones, gestiona el seguimiento de proyectos, envía actualizaciones a clientes y alerta sobre desviaciones de plazos o presupuesto.",
    
    metrics: {
      timeSaved: "25 horas/mes",
      costReduction: "45%",
      productivityIncrease: "70%",
      roi: "380%",
      paybackPeriod: "2 meses"
    },
    
    impactBefore: [
      { metric: "Tiempo por presupuesto", value: "5h" },
      { metric: "Proyectos gestionables", value: "8" },
      { metric: "Desviaciones detectadas", value: "Tarde" }
    ],
    
    impactAfter: [
      { metric: "Tiempo por presupuesto", value: "45min" },
      { metric: "Proyectos gestionables", value: "15" },
      { metric: "Desviaciones detectadas", value: "Tiempo real" }
    ],
    
    features: [
      "Generación automática de presupuestos",
      "Seguimiento de proyectos en tiempo real",
      "Alertas de desviaciones de plazos",
      "Actualizaciones automáticas a clientes",
      "Panel de control unificado"
    ],
    
    testimonial: {
      text: "En 3 meses duplicamos la capacidad de proyectos sin contratar más personal. El ROI fue espectacular.",
      author: "Laura Ruiz",
      role: "Directora del Estudio"
    },
    
    date: "10 Febrero 2026"
  }
];

export const roiBenefitsData = {
  title: "El Impacto Real de un Agente IA 24/7",
  subtitle: "Métricas promedio de nuestros clientes en los primeros 3 meses",
  
  stats: [
    {
      metric: "40-60h",
      label: "Ahorradas por mes",
      icon: "clock"
    },
    {
      metric: "45-60%",
      label: "Reducción de costes",
      icon: "trending-down"
    },
    {
      metric: "24/7",
      label: "Disponibilidad",
      icon: "zap"
    },
    {
      metric: "350-420%",
      label: "ROI promedio",
      icon: "target"
    }
  ],
  
  advantages: [
    {
      title: "Sin Descansos",
      description: "El agente trabaja 24/7/365 sin vacaciones, bajas o días festivos",
      icon: "clock"
    },
    {
      title: "Escalabilidad Inmediata",
      description: "Maneja picos de trabajo sin coste adicional ni estrés del equipo",
      icon: "trending-up"
    },
    {
      title: "Consistencia Total",
      description: "Cada interacción sigue el mismo estándar de calidad, sin variaciones",
      icon: "check-circle"
    },
    {
      title: "ROI Medible",
      description: "Cada hora ahorrada y cada proceso optimizado se traduce en ahorro real",
      icon: "dollar-sign"
    }
  ]
};
